import Transaction from "@/classes/Transaction.ts";

export default class Income extends Transaction {
  type: "income" = "income";
}
